import { Box } from '@mui/material';
import type { ReactNode } from 'react';
import { ValueText } from './LabeledValue';

/**
 * A number in the mono face, then its muted unit. Too long for its line, it
 * wraps at its spaces rather than being cut short, and the unit stays with
 * the last number.
 */
export default function NumberValue({
    value,
    unit,
    'data-testid': testId,
}: {
    value: ReactNode;
    unit?: string;
    'data-testid'?: string;
}) {
    return (
        <ValueText
            component="span"
            data-testid={testId}
            sx={{ whiteSpace: 'normal', textOverflow: 'clip' }}
        >
            <Box component="span" fontFamily="fontFamilyMonospace">
                {value}
            </Box>
            {unit && (
                <Box component="span" color="text.secondary" fontWeight={400}>
                    {`\u00a0${unit}`}
                </Box>
            )}
        </ValueText>
    );
}
